"use strict";
/**
 * Material Contribution Types V2
 *
 * Matches actual implementation in material-contribution-moderation.ts
 * Used for moderation workflow of user-submitted materials
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialScanResult = void 0;
// Re-export enum as canonical type
const scan_result_1 = require("../enums/scan-result");
Object.defineProperty(exports, "MaterialScanResult", { enumerable: true, get: function () { return scan_result_1.MaterialScanResult; } });
